export default "__VITE_ASSET__BPjl6qoc__"